import Card2 from "../body/card2";
import "./index.css";

const ContactUs = () => {
    const handleSubmit = async (e) => {
        e.preventDefault();

        // Collect data from form fields
        const form = e.target;
        const formData = new FormData(form);

        const Sheet_Url =
            "https://script.google.com/macros/s/AKfycbwTtJCthyEa3ir405gICcEOX5ZImpFLIYdPgeXzmeu-6Nd8BSZAd5PURrwTlsPNycQyag/exec";

        try {
            const response = await fetch(Sheet_Url, {
                method: "POST",
                body: formData,
            });

            if (response.ok) {
                console.log("Form submitted successfully!");
                alert("Thank you! We will get back to you soon."); // Show success message
                form.reset(); // Clear the form fields
            } else {
                alert("Oops! There was an error submitting your form. Please try again.");
                console.error("Error submitting the form:", response.statusText);
            }
        } catch (error) {
            alert("Oops! Something went wrong. Please try again.");
            console.error("Fetch error:", error);
        }
    };

    return (
        <>
            <div className="contact-form-container">
                <h1>Hey there!</h1>
                <p>We would love to have a conversation with you!</p>
                <div style={{ display: "flex", gap: "20px", padding: "20px" }} className="container-form-mini-container-mobile">
                    <div className="contact-form-mini-container" style={{ maxWidth: "252px" }}>
                        <p className="contact-us-text">Office</p>
                        <p className="contact-us-text-2" style={{ textAlign: "left" }}>⁠We are located in Noida (Uttar Pradesh) and Gujarat.</p>
                    </div>

                    <div className="contact-form-mini-container" >
                        <p className="contact-us-text">Call us now</p>
                        <a href={"tel:+918160270044"} className="contact-us-text-2"> +91 8160270044</a>
                        <a href={"tel:+917906003386"} className="contact-us-text-2"> +91 7906003386</a>
                    </div>
                </div>

                <form className="contact-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input type="text" name="firstName" placeholder="first name" required />
                        <input type="text" name="lastName" placeholder="last name" required />
                    </div>
                    <div className="form-group">

                        <input type="tel" name="phoneNumber" placeholder="phone number" required />
                    </div>

                    <div className="form-group">
                        <select name="source" required style={{ color: "#858585" }}>
                            <option value="" disabled selected>
                                Where did you hear about us
                            </option>

                            <option value="Google Search">Google Search</option>
                            <option value="Email">From Friend</option>
                            <option value="Linkedin">Brokerage Sites </option>
                            <option value="Phone">Others (Please fill in message for others)</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <textarea name="message" placeholder="message" rows="4" required></textarea>
                    </div>
                    <button type="submit">Submit</button>
                </form>

                <div style={{ marginBottom: "120px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Card2 />
                </div>
            </div>
            <section>
                <div className="image-container">
                    <img src="./polygon2.png" alt="polygon" style={{ position: "relative" }} />
                </div>
            </section>
        </>
    );
};

export default ContactUs;
